import React, { useEffect, useState, useMemo, useRef } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
    settheTicketViewIds,
    settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions,
    settheTicketraiseroutes,
    getSideBarfilesActions,
    SettheTicketDashboardStatusManagement
} from "../../../../Redux/Slice";
import _ from "lodash";
import saerchfileds from "../../../../Assets/AppComponent/Vector (33).svg"
import { useNavigate } from "react-router-dom";
import boximg from "../../../../Assets/AppComponent/Group 427320177.svg";
import Filterimg from "../../../../Assets/AppComponent/Vector (40).svg";
import $ from "jquery";


const TicketsTable = (props) => {
    const { activeButton, setActiveButton } = props
    const [selectedTab, setSelectedTab] = useState(activeButton);
    const [searchQuery, setSearchQuery] = useState('');
    const dispatch = useDispatch();
    const state = useSelector((state) => state)
    const priorityOptions = [
        { value: "", label: "All" },
        { value: "0", label: "Low" },
        { value: "1", label: "Medium" },
        { value: "2", label: "High" },
    ];

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState("");
    const [tempOption, setTempOption] = useState("");
    const popupRef = useRef(null);

    const togglePopup = () => setIsOpen(!isOpen);

    const handleCheckboxChange = (isChecked, event, data, key) => {
        // setlistofCheck({
        //     ...listsodcheck,
        //     [val.target.name]: e,
        // });
        setlistofCheck({
            check1: key === 1 ? isChecked : false,
            check2: key === 2 ? isChecked : false,
            check3: key === 3 ? isChecked : false,
            check4: key === 4 ? isChecked : false,
        });
    
        setSelectedOptions(isChecked ? data : ""); // Only store the selected value
    };

  
   

    const navigate = useNavigate();
    const [listsodcheck, setlistofCheck] = useState({
        check1: false,
        check2: false,
        check3: false,
        check4: false,
        check5: false,
    });

    useEffect(() => {
        dispatch(settheTicketraiseroutes(0))
    }, [])
    useEffect(() => {
        const payload = {
            search: searchQuery,
            page_size: 20,
            page: 1,
            priority: selectedOptions,
            status: activeButton == "All" ? "" : activeButton == "Open" ?
                "0" : activeButton == "In Progress" ? "1" : activeButton == "Review" ? "2" : activeButton == "Resolved" ? "3" :
                    activeButton == "Reopen" ? "4" : activeButton == "Reject" && 5,
            ticket_assign: false,

        };
        dispatch(settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions(payload));
        setIsOpen(false)
    }, [activeButton, searchQuery, selectedOptions]);

    // console.log(state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData,
    //     "TrackingrecordgetInternalDepartmentsListOfSystemData"
    // );

    const HandletheviewCall = () => {

        setTimeout(() => {
            dispatch(settheTicketraiseroutes(1));

        }, 100); dispatch(getSideBarfilesActions("Created Tickets  "));
        navigate("/internalTicket")

    }


    const statusTabs = ['All', 'Open', 'In Progress', 'Review', 'Rejected', 'Reopen', 'Resolved'];
    const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);
        return `${formattedDate}`;
    };
    function tochange(e) {
        debouncedSearch(e);

    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setSearchQuery(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);
    const HandletheActived = (tab) => {
        props.HandletheActived(tab)
    }
    const HandleTicketViewparts = (data) => {
        // setTimeout(() => {
        dispatch(settheTicketViewIds(data.id)); /// ticket id
        // }, 300);
        navigate("/internalTicketView")
    }


    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };
    // console.log(selectedTab, "asduasid pasiud selectedTab", state.NeededdatasListed.TicketDashboardMangements);
    // Close the popup when clicking outside


    // $(".App").on("click", function () {
    //     $(".HidentheFilter").hide();
    //   });

    // Close popup when clicking outside
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (popupRef.current && !popupRef.current.contains(event.target)) {
    //             setIsOpen(false);
    //         }
    //     };

    //     if (isOpen) {
    //         document.addEventListener("mousedown", handleClickOutside);
    //     }

    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [isOpen]);


    return (
        <div className="tickets-container" ref={popupRef}>
            <div className="tickets-header">
                <div className="tabs">
                    {statusTabs.map(tab => (
                        <button
                            key={tab}
                            className={`tab ${activeButton === tab ? 'active' : ''}`}
                            onClick={() => {
                                HandletheActived(tab)
                                setSelectedTab(tab);
                                setActiveButton(tab)
                            }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                <div className="TableFilterSearchedresults">
                    <div className="SearchFields">

                        <img src={saerchfileds} />
                        <input
                            type="text"
                            placeholder="Search..."
                            className="search-input"
                            // value={searchQuery}
                            onChange={(e) => tochange(e.target.value)}
                        />


                    </div>
                    <div className="TableFilterofBoxs">
                        <img src={Filterimg} alt="Filter" onClick={togglePopup} style={{ cursor: "pointer" }} />

                        {/* {isOpen && (
                            <div className="popup HidentheFilter">
                                <div className="popup-content">
                                    {priorityOptions.map((option) => (
                                        <label key={option.value}>
                                            <input
                                                type="radio"
                                                name="priority"
                                                value={option.value}
                                                checked={selectedOptions.includes(option.value)}
                                                onChange={() => handleCheckboxChange(option.value)}
                                            />
                                            {option.label}
                                        </label>
                                    ))}


                                    <div className="popup-buttons">
                                        <button onClick={handleOk}>OK</button>
                                        <button onClick={handleCancel}>Cancel</button>
                                    </div>


                                </div>
                            </div>
                        )} */}


                        {isOpen == true ? (
                            <div className="col-2 Subjectpopup">
                                <div className="SubjectBox">
                                    <ul class="list-group ">
                                        <li className={` list-group-item `}>
                                            All
                                            <input
                                                type="checkbox"
                                                className="form-controls"
                                                checked={listsodcheck.check1}
                                                name="check1"
                                                onChange={(e) => {
                                                    handleCheckboxChange(
                                                        !listsodcheck.check1,
                                                        e,
                                                        "",
                                                        1
                                                    );
                                                }}
                                            />
                                        </li>
                                        <li className={` list-group-item `}>
                                            Low
                                            <input
                                                type="checkbox"
                                                className="form-controls"
                                                checked={listsodcheck.check2}
                                                name="check2"
                                                onChange={(e) => {
                                                    handleCheckboxChange(
                                                        !listsodcheck.check2,
                                                        e,
                                                        "0",
                                                        2
                                                    );
                                                }}
                                            />
                                        </li>
                                        <li className={` list-group-item`}>
                                            Medium
                                            <input
                                                type="checkbox"
                                                className="form-controls"
                                                name="check3"
                                                checked={listsodcheck.check3}
                                                onChange={(e) => {
                                                    handleCheckboxChange(
                                                        !listsodcheck.check3,
                                                        e,
                                                        "1",
                                                        3
                                                    );
                                                }}
                                            />
                                        </li>
                                        <li className="list-group-item">
                                            High
                                            <input
                                                type="checkbox"
                                                className="form-controls"
                                                name="check4"
                                                checked={listsodcheck.check4}
                                                onChange={(e) => {
                                                    handleCheckboxChange(
                                                        !listsodcheck.check4,
                                                        e,
                                                        "2",

                                                        4
                                                    );
                                                }}
                                            />
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        ) : null}



                    </div>
                </div>
            </div>



            <table className="tickets-table">
                <thead>
                    <tr>
                        {/* <th>T.no</th> */}
                        <th>Created</th>
                        <th>Department</th>
                        <th>Category</th>
                        <th>Subcategory</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Priority</th>
                    </tr>
                </thead>
                <tbody>
                    {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.length > 0 ?
                        <>
                            {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.slice(0, 3).map((ticket, index) => (

                                <tr key={index} onClick={() => HandleTicketViewparts(ticket)}>

                                    <td>{formatedDateListwithouttime(ticket.created_at)}</td>
                                    <td>{ticket.department_id?.department_name ? ticket.department_id?.department_name : "--"}</td>
                                    <td>{ticket.internal_category_id?.issue_category_id?.name ? ticket.internal_category_id?.issue_category_id?.name : "--"}</td>
                                    <td>{ticket.internal_category_id?.name ? ticket?.internal_category_id?.name : "--"}</td>

                                    <td>{truncateText(ticket.remarks, 50)}</td>
                                    {/* <td>
                                <span className={`status-badge ${ticket.status.toLowerCase()}`}>
                                    {ticket.status}
                                </span>
                            </td> */}
                                    <td>
                                        {/* <span className={`status-badge ${ticket.status == 0
                                            ? "open" :
                                            ticket.status == 1 ? "inprogress" :
                                                ticket.status == 2 ? "resolved" :
                                                    ticket.status == 3 ? "resolved" :
                                                        ticket.status == 4 ? "reopen" :
                                                        ticket.status == 5 && "reopen"

                                            }`}
                                             */}
                                        <span className="status-badge"
                                            style={{
                                                background: ticket?.status == 0 ? "#FFDDDD" : // Open - light background
                                                    ticket?.status == 1 ? "#FFF8E5" : // In Progress - yellow background
                                                        ticket?.status == 2 ? "#E7F8ED" : // Completed - light green background
                                                            ticket?.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                                                ticket?.status == 4 ? "#FFDDDD" : ticket?.status == 5 && "#FFDDDD", // Default for Reopen - light red background
                                                color: ticket?.status == 0 ? "#ED4C28" : // Open - red text
                                                    ticket?.status == 1 ? "#FFB800" : // In Progress - yellow text
                                                        ticket?.status == 2 ? "#12B749" : // Completed - green text
                                                            ticket?.status == 3 ? "#8BC34A" : // Close - light green text for Close
                                                                ticket?.status == 4 ? "#ED4C28" : ticket?.status == 5 && "#ED4C28", // Default for Reopen - red text
                                            }}

                                        >
                                            {ticket.status == 0
                                                ? "Open"
                                                : ticket.status == 1
                                                    ? "In Progress"
                                                    : ticket.status == 2
                                                        ? "Review"
                                                        : ticket.status == 3
                                                            ? "Resolved"
                                                            : ticket.status == 4 ? "Reopened" :
                                                                ticket.status == 5 && "Reject"}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`priority-badge ${ticket.priority == "0" ?
                                            "low" :
                                            ticket.priority == "1" ?
                                                "medium" :
                                                ticket.priority == "2" && "high"

                                            }`}>

                                            {ticket?.priority === "0" || ticket?.priority === "1" || ticket?.priority === "2" ? (
                                                <>
                                                    {ticket?.priority === "0" ? "Low" : ticket?.priority === "1" ? "Medium" : "High"}
                                                </>
                                            ) : (
                                                "---"
                                            )}

                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </>
                        :
                        null

                    }
                </tbody>
            </table>
            {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData != undefined &&
                state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.length > 0 ?
                <>
                </>
                : <>
                    <div>

                        <div className="Dusbinbacktabls">

                            <div>
                                <img src={boximg} />
                                <p className="text-center">
                                    {"No Data Tickets Available"}
                                </p>

                            </div>
                        </div>
                    </div>
                </>
            }

            <div className="view-all">
                {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.length > 0 && (
                    <button className="view-all-button" onClick={() => HandletheviewCall()}>View All</button>
                )}
            </div>
        </div>
    );
};

export default TicketsTable;